import { useEffect, useState } from 'react'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Box } from '@mui/system'
import { connect, useSelector } from 'react-redux'
import DropDownOA from '../../../../common/dropDownOA'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import { Button } from '@mui/material'
import Datepicker from '../../../../common/datePicker'
import moment from 'moment'
import { addDaysToDate, appendToUrl, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray, subtractDaysFromDate } from '../../../../common/helper'
import { SplitButton } from '../../../../common/SplitButton'
import SummaryReport from './SummaryReport'
import DetailedReport from './DetailedReport'
import { GetMOFPaymentUpdate, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import * as mdt from '../../../../common/modaltypes'

import {frenchDeliveryUpdatedColumn, reportViewList } from './DelFranchiseeConstant'
import ManageColumns from '../../../../common/ManageColumnsUI'
import { getCompanyList, getFranchiseeDeliveryReportFilterData, getFranchiseeDeliveryReportTableData } from '../../../../../store/reports/reports_action'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import { paymentModeAll } from '../../../../common/constants'
import * as urls from '../../oldReportsUrls'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../../common/jotaiState/reportStateAtom'
import { useAtom } from 'jotai'

const DeliveryFranchiseeCompany = (props) => {
  const {
    data: { common, reports },
    updateModal,
    getFranchiseeDeliveryReportFilterData,
    getFranchiseeDeliveryReportTableData,
    updateAlertError,
    getCompanyList,
    GetMOFPaymentUpdate,
  } = props
  const companySetting = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySetting?.DefaultCurrencyID;
  const { loginData, roleRights, showModal, modalType, methodOfPayment, companySettings } = common
  const allowFormatLR = companySettings?.[0]?.UseFormattedLRinReports
  const DeliveryReportPortrait  = companySettings?.[0]?.DeliveryReportPortrait || 0
  const { reportCompany } = reports
  const UseToPayAsCOD=companySettings.UseToPayAsCOD
  const [selCompany, setSelCompany] = useState('')
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selFranchiseeCity, setSelFranchiseeCity] = useState()
  const [selOwnBookingBranch, setSelOwnBookingBranch] = useState()
  const [selFranchiseeBranch, setSelFranchiseeBranch] = useState()
  const [selOwnBookingCity, setSelOwnBookingCity] = useState()
  const [selOwnBookingBranchUser, setSelOwnBookingBranchUser] = useState()
  const [resetFlag, setResetFlag] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [showReport, setShowReport] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [filterData, setFilterData] = useState([])
  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const [paymentMode, setPaymentMode] = useState(paymentModeAll)
  const [paymentModeData, setPaymentModeData] = useState([])
  const [tableDataDetail, setTableDataDetail] = useState([])
  const [tableDataSummary, setTableDataSummary] = useState([])
  const [selReportView, setSelReportView] = useState(reportViewList[1])
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  useEffect(() => {
    const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) || ChildCompanyList[0];
    setSelCompany(defaultCompany)
  }, [ChildCompanyList])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intCompanyID: loginData?.intCompanyID,
        UserID: loginData?.intUserID
      }
      fetchChildCompanyList(body)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      GetMOFPaymentUpdate({ intBranchID: loginData?.intBranchID })
      const companylistData = {
        intCompanyID: loginData?.intCompanyID,
        intUserID: loginData?.intUserID,
        intMode: 0,
      }
      getCompanyList(companylistData)
    }
  }, [loginData])
  useEffect(() => {
    //default value
    if (filterData?.length > 0) {
      let franchiseeCityOption = removeDuplicatesFromArray(filterData, 'FranchiseCity')
      let franchiseeBranchOption = removeDuplicatesFromArray(filterData, 'FranchiseBranchID')
      let ownBookingCityOption = removeDuplicatesFromArray(filterData, 'BookingCity')
      let ownBookingBranchOption = removeDuplicatesFromArray(filterData, 'BookingBranchID')
      let ownBookingBranchuserOption = removeDuplicatesFromArray(filterData, 'UserID')
      setSelFranchiseeCity(franchiseeCityOption[0])
      setSelFranchiseeBranch(franchiseeBranchOption[0])
      setSelOwnBookingCity(ownBookingCityOption[0])
      setSelOwnBookingBranch(ownBookingBranchOption[0])
      setSelOwnBookingBranchUser(ownBookingBranchuserOption[0])

    } else {
      //setSourceCityData([])
      // }
    }
  }, [filterData])
  const updatedCol=frenchDeliveryUpdatedColumn(allowFormatLR,loginCountryId)
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }
    const updateColumnDetails = async () => {
      try {
        const localDelFranchiseeCol = await getLocalData('updatedColKey')
        let filnalcol=localDelFranchiseeCol||updatedCol
        if(DeliveryReportPortrait ===1){
          filnalcol = filnalcol.filter((item)=>item.isMandatory)
        }
        setManageColumn(filnalcol)
      } catch (error) {
        setManageColumn(updatedCol)
        console.error(error)
      }
    }
    updateColumnDetails()
    focusElemnt(id.selectCompnay)

  }, [DeliveryReportPortrait,loginCountryId,allowFormatLR])

  useEffect(() => {
    if (methodOfPayment?.status === "Success") {
      const modeData = methodOfPayment?.Data?.Table?.filter((val) => val?.ModeID !== 2)
      setPaymentModeData([paymentModeAll, ...modeData])
    }
  }, [methodOfPayment])
  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem('updatedColKey', JSON.stringify(item))
  }
  let selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
  const mainHeader = ['srNo', 'LRNO',...(allowFormatLR === 3 ? ['FormattedLRNO'] : []), 'DelDate', 'SrcCity', 'DispByCity', 'SndrName', 'SndrGSTIN', 'RcvrName', 'RcvrGSTIN', 'Item']
  const matchFields = Object.fromEntries(
    Object.entries(selectedFields).filter(([key]) => mainHeader.includes(key))
  );
  let franchiseeCityOption = removeDuplicatesFromArray(filterData, 'FranchiseCity')
  let franchiseeBranchOption = removeDuplicatesFromArray(filterData, 'FranchiseBranchID')
  let ownBookingCityOption = removeDuplicatesFromArray(filterData, 'BookingCity')
  let ownBookingBranchOption = removeDuplicatesFromArray(filterData, 'BookingBranchID')
  let ownBookingBranchuserOption = removeDuplicatesFromArray(filterData, 'UserID')

  const handleGoClick = () => {
    if ((moment(toDate).startOf().diff(moment(fromDate).endOf(), 'days')) > 30) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    }
    else {
      const obj = {
        CompanyID: loginData.intCompanyID,
        FranchiseeCompanyID: selCompany?.CompanyID,
        dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(toDate).format('YYYY-MM-DD'),
        LoginUserID: loginData.intUserID
        // FranchiseeCompanyID: 31,
        // dtFromDate: '2024-01-01',
        // dtToDate: '2024-02-21',
        // LoginUserID: 0
      }
      getFranchiseeDeliveryReportFilterData(obj).then((val) => {
        if (val.status === "Success") {
          if (val.Data.Table?.length > 0) {
            setFilterData(val.Data.Table)
          } else {
            updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
          }
        } else {
          //handle error
          setFilterData([])
          updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
        }
      })

    }
  }
  const handleClick2 = () => {
    if ((moment(toDate).startOf().diff(moment(fromDate).endOf(), 'days')) > 30) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      let url = urls.deliveryReportFranchisee
      const urlData = urls.deliveryReportFranchiseeParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.intCompanyID = loginData.intCompanyID
      urlData.intBranchID = selOwnBookingBranch?.BookingBranchID
      urlData.intUserID = loginData?.intUserID
      urlData.intFranchCompanyID = selCompany?.CompanyID
      urlData.intFranchBranchID = selFranchiseeBranch?.FranchiseBranchID
      urlData.dtFromDate = fromDate.format('DD-MMM-YYYY')
      urlData.dtToDate = toDate.format('DD-MMM-YYYY')
      urlData.intPaymentType = paymentType?.typeId
      urlData.PaymentType = paymentType?.name
      urlData.BookedByBranch = selOwnBookingBranch?.BookingBranch
      urlData.FranchiseeCompany = selCompany?.CompanyName
      urlData.FranchiseeBranch = selFranchiseeBranch?.FranchiseBranch
      url = appendToUrl(url, urlData);
      window.open(url, "_blank")
    }
  }
  const handleClick1 = () => {
    if ((moment(toDate).startOf().diff(moment(fromDate).endOf(), 'days')) > 30) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    }else {
      if (selFranchiseeCity === "" || selFranchiseeCity === " ") {
        updateAlertError({ show: true, msg: 'Select Franchisee Delivery City', nextId: '' })
      } else {
        const obj = {
          CompanyID: loginData?.intCompanyID,
          BranchID: selOwnBookingBranch?.BookingBranchID,
          // UserID: selOwnBookingBranchUser?.UserID,
          UserID: 0,//default all user selected with disabled
          dtFromDate: moment(fromDate).format("YYYY-MM-DD"),
          dtToDate: moment(toDate).format("YYYY-MM-DD"),
          FranchCompanyID: selCompany?.CompanyID,
          FranchBranchID: selFranchiseeBranch?.FranchiseBranchID,
          FranchCityID: 0,//default
          PaymentType: paymentType?.typeId,
          PaymentMode: paymentMode?.ModeID,
          // CompanyID: 1,
          // BranchID: 1,
          // UserID: 0,
          // dtFromDate: '2024-01-01',
          // dtToDate: '2024-02-21',
          // FranchCompanyID: 31,
          // FranchBranchID: 146,
          // FranchCityID: 0,//default
          // PaymentType: 0,
          // PaymentMode: 0,
        }
        getFranchiseeDeliveryReportTableData(obj).then((val) => {
          if (val.status === "Success") {
            if (val?.Table?.length > 0 || val?.Table1?.length > 0) {
              setShowReport(true)
              setTableDataDetail(val?.Table)
              const data=val?.Table1.map((val)=>({...val,PaymentType:UseToPayAsCOD===1&&val.PaymentType==='TOPAY'?'COD':val.PaymentType==='TOPAY(MANUAL)'?'COD(MANUAL)':val.PaymentType}))
              setTableDataSummary(val?.Table1)
            } else {
              updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
            }
          } else {
            //handle error
            setShowReport(false)
            setTableDataDetail([])
            setTableDataSummary([])
            updateAlertError({ show: true, msg: val?.ErrMessage, nextId: '' })
          }
        })
      }
    }
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompnay}
              nextId={id.fromDate}
              prevId={showReport ? isPdfLoading ? "backBtn" : 'printBtn' : id.reportmainButton}
              label="Selected Company"
              data={ChildCompanyList}
              defaultvalue={selCompany?.CompanyName}
              disabled={ChildCompanyList?.length > 0 ? false : true}
              onSelect={(e) => {
                setSelCompany(e)
                setShowReport(false)
                focusElemnt(id.fromDate)
              }}
              dataKey={`CompanyName`}
              idKey={`CompanyID`}
              minWidth="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_date'}
              label={`From Delivery Date`}
              value={fromDate}
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              width="100%"
              //startDate={'2022-01-01'}
              startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_date'}
              label={`To Delivery Date`}
              id={id.toDate}
              value={toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('filterGo')
              }}
              width="100%"
              startDate={fromDate}//to date can not be before fromdate
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date

            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button id='filterGo' variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
              onKeyDown={(e) => {
                navigation3(e, id.FranchiseeDelCity, id.toDate, () => { })
              }}
              onClick={handleGoClick}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Franchisee Del. City'}
              id={id.FranchiseeDelCity}
              data={franchiseeCityOption}
              defaultvalue={selFranchiseeCity?.FranchiseCity || selFranchiseeCity}
              resetFlag={resetFlag}
              dataKey={`FranchiseCity`}
              idKey={`FranchiseCity`}
              width="100%"
              //disabled={true}
              nextId={id.FranchiseeDelBranch}
              prevId={'filterGo'}
              onSelect={(e) => {
                setSelFranchiseeCity(e)
                setShowReport(false)
                // focusElemnt(`GOCompanyData`)
              }}
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Franchisee Del. Branch'}
              id={id.FranchiseeDelBranch}
              data={franchiseeBranchOption}
              defaultvalue={selFranchiseeBranch?.FranchiseBranch || selFranchiseeBranch}
              resetFlag={resetFlag}
              dataKey={`FranchiseBranch`}
              idKey={`FranchiseBranchID`}
              width="100%"
              nextId={id.OwnBookingCity}
              prevId={id.FranchiseeDelCity}
              onSelect={(e) => {
                setSelFranchiseeBranch(e)
                setShowReport(false)
                // focusElemnt(`GOCompanyData`)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.OwnBookingCity}
              id={id.OwnBookingCity}
              data={ownBookingCityOption}
              defaultvalue={selOwnBookingCity?.BookingCity || selOwnBookingCity}
              resetFlag={resetFlag}
              dataKey={`BookingCity`}
              idKey={`BookingCity`}
              width="200px"
              nextId={id.OwnBookingBranch}
              prevId={id.FranchiseeDelBranch}
              onSelect={(e) => {
                setSelOwnBookingCity(e)
                setShowReport(false)
                // focusElemnt(`GOCompanyData`)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.OwnBookingBranch}
              id={id.OwnBookingBranch}
              data={ownBookingBranchOption}
              defaultvalue={selOwnBookingBranch?.BookingBranch || selOwnBookingBranch}
              resetFlag={resetFlag}
              dataKey={`BookingBranch`}
              idKey={`BookingBranchID`}
              width="180px"
              nextId={id.OwnBkgBranchUser}
              prevId={id.OwnBookingCity}
              onSelect={(e) => {
                setSelOwnBookingBranch(e)
                setShowReport(false)
                // focusElemnt(`GOCompanyData`)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.OwnBkgBranchUser}
              id={id.OwnBkgBranchUser}
              data={ownBookingBranchuserOption}
              defaultvalue={'All'}
              disabled={true}
              //defaultvalue={selOwnBookingBranchUser?.Username || selOwnBookingBranchUser}
              resetFlag={resetFlag}
              dataKey={`Username`}
              idKey={`UserID`}
              width="190px"
              nextId={id.paymentType}
              prevId={id.OwnBookingBranch}
              onSelect={(e) => {
                setSelOwnBookingBranchUser(e)
                setShowReport(false)
                // focusElemnt(`GOCompanyData`)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.paymentType}
              id={id.paymentType}
              // data={paymentModesWithAll || []}
              data={
                (paymentModesWithAll || []).map((item) => {
                  if (UseToPayAsCOD === 1) {
                    if (item.typeId === 2) {
                      return { ...item, name: 'COD' };
                    }
                    if (item.typeId === 7) {
                      return { ...item, name: 'COD Manual' };
                    }
                    if (item.typeId === 9) {
                      return { ...item, name: 'COD DDDV' };
                    }
                    if (item.typeId === 4) {
                      return null;
                    }
                  }
                  return item;
                }).filter(Boolean)
              }
              resetFlag={resetFlag}
              dataKey={`name`}
              idKey={`typeId`}
              width="180px"
              nextId={id.PaymentMode}
              prevId={id.OwnBkgBranchUser}
              defaultvalue={paymentType?.name}
              onSelect={(value) => {
                setPaymentType(value)
                setShowReport(false)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.PaymentMode}
              id={id.PaymentMode}
              data={paymentModeData || []}
              defaultvalue={paymentModeData?.length > 0 && paymentMode?.ModeName}
              resetFlag={resetFlag}
              dataKey={`ModeName`}
              idKey={`ModeID`}
              width="185px"
              nextId={id.reportView}
              prevId={id.paymentType}
              onSelect={(value) => {
                setPaymentMode(value)
                setShowReport(false)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={lb.reportView}
              id={id.reportView}
              data={reportViewList || []}
              defaultvalue={selReportView?.name || selReportView}
              value={selReportView?.name || selReportView}
              // onSelect={setSelReportView}
              onSelect={(value) => {
                setSelReportView(value)
                setShowReport(false)
              }}
              resetFlag={resetFlag}
              dataKey={`name`}
              idKey={`id`}
              width="185px"
              nextId={id.reportmainButton}
              prevId={id.PaymentMode}
            />
          </Item>
          <Item sx={sx.itemsx}
            onKeyDown={(e) => {
              navigation3(e, showReport ? isPdfLoading ? "backBtn" : disableExcel ? "exportPdf" : "exportExcelBtn" : id.selectCompnay, id.reportView, () => { })
            }}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              hideToggle={false}
              id1={id.reportmainButton}
              // onClick1={() => {
              //   setShowReport(true)
              // }}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
        </Box>
        {showReport ? (selReportView?.id === 0 ?
          <SummaryReport loginCountryId={loginCountryId} isPdfLoading={isPdfLoading} loginData={loginData} setIsPdfLoading={setIsPdfLoading} tableData1={tableDataSummary} headerFilterData={{
            FranchiseCompany: selCompany?.CompanyName,
            FranchiseeDelCity: selFranchiseeCity?.FranchiseCity,
            FranchiseeDelBranch: selFranchiseeBranch?.FranchiseBranch,
            OwnBookingCity: selOwnBookingCity?.BookingCity,
            OwnBookingBranch: selOwnBookingBranch?.BookingBranch,
            OwnBookingBranchUser: selOwnBookingBranchUser?.Username,
            PaymentType: paymentType?.name,
            PaymentMode: paymentMode?.ModeName,
            FromDate: moment(fromDate).format("DD-MMM-YYYY"),
            ToDate: moment(toDate).format("DD-MMM-YYYY")
          }} />
          :
          <DetailedReport
            loginCountryId={loginCountryId}
            loginData={loginData}
            isPdfLoading={isPdfLoading}
            setIsPdfLoading={setIsPdfLoading}
            updateModal={updateModal}
            columnDefs={manageColumn?.filter((obj) => obj.isSelected)}
            selectedFields={selectedFields}
            matchFields={matchFields}
            tableData1={tableDataDetail}
            allowFormatLR={allowFormatLR}
            headerFilterData={{
              FranchiseCompany: selCompany?.CompanyName,
              FranchiseeDelCity: selFranchiseeCity?.FranchiseCity,
              FranchiseeDelBranch: selFranchiseeBranch?.FranchiseBranch,
              OwnBookingCity: selOwnBookingCity?.BookingCity,
              OwnBookingBranch: selOwnBookingBranch?.BookingBranch,
              OwnBookingBranchUser: selOwnBookingBranchUser?.Username,
              PaymentType: paymentType?.name,
              PaymentMode: paymentMode?.ModeName,
              FromDate: moment(fromDate).format("DD-MMM-YYYY"),
              ToDate: moment(toDate).format("DD-MMM-YYYY")
            }}
          />)
          : ''
        }
      </Item >
      {showModal && mdt.LRWiseDetailsReport === modalType ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} /> : null}
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getFranchiseeDeliveryReportFilterData, updateAlertError, getFranchiseeDeliveryReportTableData, getCompanyList, GetMOFPaymentUpdate }

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryFranchiseeCompany)